import { toDataURL } from 'qrcode';
import { useEffect, useState } from 'react';

type Props = {
  readonly value: string;
  readonly size?: number;
};

const QrCode = ({ value, size = 200 }: Props) => {
  const [dataUrl, setDataUrl] = useState<string>();

  useEffect(() => {
    (async () => {
      try {
        setDataUrl(await toDataURL(value, { width: size, margin: 1 }));
      } catch {
        setDataUrl(undefined);
      }
    })();
  }, [value, size]);

  if (!dataUrl) {
    return null;
  }

  return <img src={dataUrl} alt="QR code" width={size} height={size} />;
};

export default QrCode;
